import { ApiProvider } from "Core"

export const deleteIAMRole = async (role) => {
  await new ApiProvider('iamactions').setInstance(role).delete()
  return role
}